import React from 'react';

/**
 * Full-dashboard shimmer skeleton shown briefly on first paint while the
 * premium UI mounts. Pure presentation — mirrors the real layout (main
 * column + loyalty sidebar) using the shared `.ds-skeleton-*` shimmer
 * utilities from the design system.
 */
export const DashboardSkeleton: React.FC = () => {
  return (
    <div className="ds-skeleton-screen" aria-hidden="true">
      <div className="ds-skeleton-col-main">
        <div className="ds-skeleton-block" style={{ height: 168, marginBottom: 20 }} />
        <div className="ds-skeleton-block" style={{ height: 132, marginBottom: 20 }} />
        <div className="ds-skeleton-block" style={{ height: 320, marginBottom: 20 }} />
        <div className="ds-skeleton-block" style={{ height: 380 }} />
      </div>
      <div className="ds-skeleton-col-side">
        <div className="ds-skeleton-block" style={{ height: 120, marginBottom: 20 }} />
        <div className="ds-skeleton-block" style={{ height: 300, marginBottom: 20 }} />
        <div className="ds-skeleton-block" style={{ height: 260 }} />
      </div>
    </div>
  );
};

export default DashboardSkeleton;
